import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { Container, Row, Col } from '../../components/grid'
import { Layout } from '../../components/layouts/layout'
import { PageMeta } from '../../components/page-meta'
import { StaticTemplate } from '../../templates/staticTemplate'
import { Heading } from '../../components/typography/Heading'
import { GreenhouseModule } from '../../components/modules/GreenhouseModule'
import { TitleModule } from '../../components/modules/TitleModule'
import { ElevatedTitleCentered } from '../../components/modules/ElevatedTitleCentered'
import * as styles from './open-positions.module.scss'
import { usePages } from './constants'

const OpenPositions = ({ location, pageContext }) => {
  const [t] = useTranslation()
  const { careersPage, OpenPositionsPage } = usePages()

  const headline = {
    nodeType: 'document',
    data: {},
    content: [
      {
        nodeType: 'paragraph',
        content: [
          {
            nodeType: 'text',
            marks: [],
            value: 'Open Positions',
            data: {},
          },
        ],
        data: {},
      },
    ],
  }

  const elevatedTitleHeadline = {
    nodeType: 'document',
    data: {},
    content: [
      {
        nodeType: 'paragraph',
        content: [
          {
            nodeType: 'text',
            marks: [],
            value: 'Are you an agency recruiter?',
            data: {},
          },
        ],
        data: {},
      },
    ],
  }

  const subHeadlineLineOne = t('greenhousePage.headerLineOne', {
    defaultValue: `Are you ready to make Elevations the best place you've ever worked? Check out our open positions below!`,
  })

  const subHeadlineLineTwo = t('greenhousePage.headerLineTwo', {
    defaultValue: `Don't see what you're looking for? Email us your resume at`,
  })

  const headerPostLink = t('greenhousePage.headerPostLink', {
    defaultValue: `, and we’ll add you to our talent community.`,
  })

  const subHeadline = {
    nodeType: 'document',
    data: {},
    content: [
      {
        nodeType: 'paragraph',
        content: [
          {
            nodeType: 'text',
            marks: [],
            value: subHeadlineLineOne,
            data: {},
          },
          {
            data: {},
            marks: [],
            value: '\n\n',
            nodeType: 'text',
          },
        ],
        data: {},
      },
    ],
  }

  const elevatedTitleBody = {
    nodeType: 'document',
    data: {},
    content: [
      {
        nodeType: 'paragraph',
        content: [
          {
            nodeType: 'text',
            marks: [],
            value:
              'Elevations Credit Union does not accept unsolicited resumes or outreach from third-party recruiters. Our team partners with a smart vendor management system, RecruitiFi, to streamline and enhance our agency recruitment process. To join our agency community, please create an account with RecruitiFi.',
            data: {},
          },
        ],
        data: {},
      },
    ],
  }

  return (
    <StaticTemplate pageContext={pageContext}>
      {({ navMenus }) => (
        <Layout
          location={location}
          pageContext={{ ...pageContext, pathname: '/careers/open-positions' }}
          menu={{ ...navMenus, subnav: [careersPage] }}
          showSubnav
        >
          <PageMeta
            language={pageContext.langKey}
            title={t('OpenPositions.pageTitle', { defaultValue: 'Open Positions' })}
            pathname="/careers/open-positions"
          />
          <TitleModule
            richHeadline={headline}
            richSubHeadline={subHeadline}
            backgroundColor="#02587c"
            fontColor="white"
          />
          <GreenhouseModule />
          <ElevatedTitleCentered
            richHeadline={elevatedTitleHeadline}
            richBody={elevatedTitleBody}
            buttonCta="Join our approved agency community"
            buttonUrl="https://my.recruitifi.com/app/public/agency-registration?solicited_employer=28ad3ced-fe06-49c0-9aba-ed197755b21a%27"
            buttonAlt="Join our approved agency community"
          />
        </Layout>
      )}
    </StaticTemplate>
  )
}

OpenPositions.propTypes = {
  children: PropTypes.node,
  location: PropTypes.object,
  pageContext: PropTypes.object,
}

export { OpenPositions }
export default OpenPositions
